/* eslint-disable import/prefer-default-export */
import { SET_PROGRESS_BAR_STATUS } from '../types/progressBar';

export const setProgressBarStatus = (payload: boolean) => ({
  type: SET_PROGRESS_BAR_STATUS,
  payload,
});
